export default __webpack_public_path__ + "static/media/drop_off_img.4887f556.png";